import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Grid,
} from "@mui/material";
import { useSelector } from "react-redux";

const AddCustomerDialog = ({ isOpen, onClose, initialName, onCustomerCreated }) => {

    const {
        user_id,
        company_id,
        companyCountry,
        companyState,
        is_super,
        is_admin,
        permissions,
    } = useSelector((state) => state.GlobalVariables);
    const initialFormState = {
        fname: "",
        contact_name: "",
        father_name: "",
        mobile: "",
        email: "",
        address: "",
        country: companyCountry,
        State: companyState,
        status: true,
        openingamount: 0,
    };

    const [formData, setFormData] = useState(initialFormState);

    // Validation errors store karne ke liye State
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (isOpen) {
            const nameValue = initialName || "";
            setFormData({
                ...initialFormState,
                fname: nameValue,
                contact_name: nameValue,
            });
            setErrors({}); // Dialog open hote hi purani errors clear
        }
    }, [isOpen, initialName]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Typing ke waqt error clear karna
        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: "" }));
        }
    };

    // 🔍 Main Validation Function
    const validateForm = () => {
        let tempErrors = {};

        // 1. First Name (Compulsory)
        if (!formData.fname.trim()) {
            tempErrors.fname = "First Name is required";
        }

        // 2. Mobile (Only if filled -> 10 digits check)
        if (formData.mobile.trim()) {
            const mobileRegex = /^[0-9]{10}$/;
            if (!mobileRegex.test(formData.mobile)) {
                tempErrors.mobile = "Mobile number must be 10 digits (0-9)";
            }
        }

        // 3. Email (Only if filled -> Valid format/extension check)
        if (formData.email.trim()) {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(formData.email)) {
                tempErrors.email = "Please enter a valid email address (e.g. example@domain.com)";
            }
        }

        setErrors(tempErrors);

        // Agar object empty hai toh Return True (Form Valid hai)
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Pehle validation chalayenge
        if (validateForm()) {
            // console.log("Form Submitted Successfully:", formData);

            if (onCustomerCreated) {
                onCustomerCreated(formData);
            }

            // onClose();
        }
    };

    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>➕ Add New Customer</DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        {/* First Name (Compulsory) */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="First Name *"
                                name="fname"
                                value={formData.fname}
                                onChange={handleChange}
                                error={!!errors.fname}
                                helperText={errors.fname}
                            />
                        </Grid>

                        {/* Contact Name */}
                        {/* <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                label="Contact Name"
                name="contact_name"
                value={formData.contact_name}
                onChange={handleChange}
              />
            </Grid> */}

                        {/* Father Name */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Father's Name"
                                name="father_name"
                                value={formData.father_name}
                                onChange={handleChange}
                            />
                        </Grid>

                        {/* Mobile (Validates only when user types) */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Mobile"
                                name="mobile"
                                value={formData.mobile}
                                onChange={handleChange}
                                inputProps={{ maxLength: 10 }} // Extra digits type nahi hone dega
                                error={!!errors.mobile}
                                helperText={errors.mobile}
                            />
                        </Grid>

                        {/* Email (Validates extension/format only when user types) */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                error={!!errors.email}
                                helperText={errors.email}
                            />
                        </Grid>

                        {/* Address */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Address"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                            />
                        </Grid>

                        {/* Country */}
                        {/* <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Country"
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                            />
                        </Grid> */}

                        {/* State */}
                        {/* <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="State"
                                name="State"
                                value={formData.State}
                                onChange={handleChange}
                            />
                        </Grid> */}
                    </Grid>
                </DialogContent>

                <DialogActions sx={{ padding: 2 }}>
                    <Button onClick={onClose} color="inherit" variant="outlined">
                        Cancel
                    </Button>
                    <Button type="submit" variant="contained" color="primary">
                        Save Customer
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default AddCustomerDialog;